module.exports = __webpack_public_path__ + "static/img/403.2dda86a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error/403.svg
// module id = b7Mj
// module chunks = 14